import { render, staticRenderFns } from "./categoryList.vue?vue&type=template&id=dcfebc12&"
import script from "./categoryList.vue?vue&type=script&lang=js&"
export * from "./categoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports